import { FormattedMessage } from 'react-intl';
export const PRIVATE_AREA_VIEW_ROUTE = 'private-area';
export const STATUS_VOCABULARY_ID = 'fbc.addon.LocationStatusesVocabulary';

export const MANAGER_STATUS_FLOW = {
  1: [
    {
      to: '3',
      title: <FormattedMessage id="Reject" defaultMessage="Reject" />,
    },
    {
      to: '2',
      title: <FormattedMessage id="Allow" defaultMessage="Allow" />,
    },
  ],
  2: [
    {
      to: '1',
      title: <FormattedMessage id="To Pending" defaultMessage="To Pending" />,
    },
    {
      to: '3',
      title: <FormattedMessage id="Reject" defaultMessage="Reject" />,
    },
  ],
  3: [
    {
      to: '1',
      title: <FormattedMessage id="To Pending" defaultMessage="To Pending" />,
    },
    {
      to: '2',
      title: <FormattedMessage id="Allow" defaultMessage="Allow" />,
    },
  ],
};

export const CONTACTS = {
  es: 'contacto',
  en: 'contact',
  eu: 'kontaktua',
};
